<template>
  <div class="hold-transition">
    <div class="wrapper">
      <div class="content-wrapper">
        <!-- Encabezado -->
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Reportes</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Torre de Control</li>
                  <li class="breadcrumb-item active">Operación</li>
                  <li class="breadcrumb-item">Consultas</li>
                  <li class="breadcrumb-item active">Reportes</li>
                </ol>
              </div>
            </div>
          </div>
        </section>

        <!-- Contenido -->
        <section class="content">
          <div class="container-fluid">
            <div class="card shadow-sm border-0">
              <div class="card-header bg-white border-bottom">
                <div
                  class="d-flex justify-content-between align-items-center flex-wrap"
                >
                  <div>
                    <h5 class="mb-1 text-dark">
                      <i class="fas fa-chart-line mr-2 text-primary"></i>
                      Tablero de Reportes
                    </h5>
                    <p class="mb-0 text-muted small">
                      Genera y descarga los reportes operativos del módulo de
                      frontera.
                    </p>
                  </div>
                  <span class="badge badge-primary badge-pill">
                    {{ reportes.length }} reportes disponibles
                  </span>
                </div>
              </div>

              <div class="card-body">
                <div class="row">
                  <div
                    v-for="reporte in reportes"
                    :key="reporte.key"
                    class="col-12 col-md-6 col-xl-4 mb-4"
                  >
                    <div
                      class="card h-100 shadow-sm border"
                      v-if="$store.getters.can(reporte.permiso)"
                    >
                      <div class="card-body d-flex flex-column text-center">
                        <div class="mb-3">
                          <span
                            class="d-inline-flex align-items-center justify-content-center rounded-circle bg-light"
                          >
                            <i
                              class="fa-3x p-4"
                              :class="[reporte.icono, reporte.color]"
                            ></i>
                          </span>
                        </div>
                        <h5 class="card-title mb-2 text-dark">
                          {{ reporte.titulo }}
                        </h5>
                        <p class="card-text text-muted small flex-grow-1">
                          {{ reporte.descripcion }}
                        </p>
                        <button
                          type="button"
                          class="btn btn-primary btn-block mt-3"
                          data-toggle="modal"
                          :data-target="reporte.modal"
                          @click="limpiarModal(reporte.ref)"
                        >
                          <i class="fas fa-file-export mr-1"></i>
                          Generar reporte
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ReporteTurnosTif ref="ReporteTurnosTif" />
          <ReporteTurnosTep ref="ReporteTurnosTep" />
          <ReporteViajesTep ref="ReporteViajesTep" />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import ReporteTurnosTif from "./ReporteTurnosTif.vue";
import ReporteTurnosTep from "./ReporteTurnosTep.vue";
import ReporteViajesTep from "./ReporteViajesTep.vue";

export default {
  name: "ReporteIndex",
  components: {
    ReporteTurnosTif,
    ReporteTurnosTep,
    ReporteViajesTep,
  },
  data() {
    return {
      reportes: [
        {
          key: "turnosTif",
          titulo: "Turnos TIF",
          descripcion:
            "Consolidado de turnos generados en la operación TIF dentro del rango seleccionado.",
          icono: "fas fa-clock",
          color: "text-success",
          modal: "#modal-reporte-turnos-tif",
          ref: "ReporteTurnosTif",
          permiso: "funcionariofrontera.reportes.turnosTifExport",
        },
        {
          key: "turnosTep",
          titulo: "Turnos TEP",
          descripcion:
            "Consolidado de turnos generados en la operación TEP dentro del rango seleccionado.",
          icono: "fas fa-user-clock",
          color: "text-primary",
          modal: "#modal-reporte-turnos-tep",
          ref: "ReporteTurnosTep",
          permiso: "funcionariofrontera.reportes.turnosTepExport",
        },
        {
          key: "viajesTep",
          titulo: "Viajes TEP",
          descripcion:
            "Detalle de viajes TEP con sus estados y tiempos dentro del rango seleccionado.",
          icono: "fas fa-route",
          color: "text-info",
          modal: "#modal-reporte-viajes-tep",
          ref: "ReporteViajesTep",
          permiso: "funcionariofrontera.reportes.viajesTepExport",
        },
      ],
    };
  },
  methods: {
    limpiarModal(refName) {
      if (this.$refs[refName] && this.$refs[refName].limpiarModal) {
        this.$refs[refName].limpiarModal();
      }
    },
  },
};
</script>
